import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { RNPTabs } from '../RolesAndPermissions/types';
import { FEATURE_TOGGLE } from '../../utils/FeatureToggle';
import { ROUTE_RNP } from '../../components/Routing/routeHelpers';
import appLocalStorage from '../../utils/AppLocalStorage';

const tabPaths: any = {
  [RNPTabs.SYSTEM_ROLES]: ROUTE_RNP.systemRoles,
  [RNPTabs.CUSTOM_ROLES]: ROUTE_RNP.customRoles,
};

interface Props {
  currentTab: RNPTabs;
}

const useRNP = ({ currentTab }: Props) => {
  const [selectedTab, setSelectedTab] = useState<RNPTabs>(currentTab);
  const history = useHistory();

  const [searchText, setSearchText] = useState('');

  const handleTabSelection = (id: any) => {
    setSelectedTab(id as RNPTabs);
    const updateUrl = tabPaths[id];
    history.push(updateUrl);
  };

  const showCreateNewRoleButton =
    selectedTab === RNPTabs.CUSTOM_ROLES && FEATURE_TOGGLE.RNP_CUSTOM_ROLES;

  return {
    searchText,
    setSearchText,
    showCreateNewRoleButton,
    selectedTab,
    isViewOnlyRole: appLocalStorage.isViewOnlyRole(),
    handleTabSelection,
  };
};

export default useRNP;
